import React from 'react';
import { SettingsKycCard } from './SettingsKycCard';

export const SettingsKycSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <SettingsKycCard />
    </div>
  );
};

export default SettingsKycSection;
